<template>
  <ModalBase @close-modal="() => closeHpcrDoctorModal()">
    <div class="modalLayout">
      <div class="modalContainer">
        <p class="modalTitle">
          将来のキャリアのために<br class="hiddenPc" />
          情報収集できます
        </p>
        <p class="modalText">
          医学⽣‧医師の皆様向けに、ご活⽤いただける以下のサービスを提供しております。是⾮ご利⽤ください。
        </p>
        <div class="modalInner">
          <div class="modalConts -hpcr">
            <p class="modalContsLogo">
              <img src="@/assets/images/common/logo-hpcr.svg" alt="" />
            </p>
            <p class="modalContsText">
              医師の臨床⼒とモチベーションを⾼める⽇本最⼤級のオンライン医局®です。<br />
              先輩医師の診療やキャリアのQ&A、PubMedの⽇本語検索などのお役⽴ち機能をご利⽤いただけます。
            </p>
          </div>
          <div class="modalConts -doctor">
            <p class="modalContsLogo">
              <img src="@/assets/images/common/logo-mynavi-doctor.svg" alt="" />
            </p>
            <p class="modalContsText">
              「マイナビDOCTOR」は常勤求人からスポット求人、アルバイト求人まで、最新の医師求人情報をご紹介する転職支援サービスです。<br />研修中のアルバイトを検討いただく際にもぜひご利⽤ください。
            </p>
          </div>
        </div>
      </div>
    </div>
  </ModalBase>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/runtime-core'
import ModalBase from '../genenral/ModalBase.vue'

import { useStore } from 'vuex'

export default defineComponent({
  name: 'ModalHpcrDoctor',

  components: {
    ModalBase
  },

  props: {
    closeModal: {
      type: Function as PropType<() => void>,
      required: true
    }
  },

  setup(props) {
    const store = useStore()

    const closeHpcrDoctorModal = () => {
      store.commit('unFixBody')
      props.closeModal()
    }

    return {
      closeHpcrDoctorModal
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

::v-deep(.modal) {
  height: calc(100% + 40px);
  width: 100%;
  max-width: 712px;
  margin-top: 20px;
  padding-right: 0;
  padding-left: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  @include mixins.media() {
    height: 100%;
    max-height: 518px;
    padding: 44px 88px 40px;
  }
}
.modalLayout {
  width: 100%;
  height: 100%;
  padding: 0 36px 72px;
  overflow-y: auto;
  @include mixins.media() {
    padding: 0;
  }
}

::v-deep(.modalInfo_description > a) {
  color: var.$color-main-text;
}

.modalTitle {
  font-weight: bold;
  font-size: 2.2rem;
  line-height: 1.5;
  color: var.$color-main-text;
  margin-bottom: 20px;
  text-align: center;
  @include mixins.media() {
    font-size: 2.4rem;
  }
}
.modalText {
  font-size: 1.4rem;
  line-height: 2;
}
.modalInner {
  margin-top: 24px;
  display: grid;
  gap: 16px;
  @include mixins.media() {
    grid-template-columns: 1fr 1fr;
  }
}
.modalConts {
  border-radius: 10px;
  padding: 24px 20px 36px;
  &.-hpcr {
    background-color: #f4f6f1;
  }
  &.-doctor {
    background-color: #eef8f8;
  }
}
.modalContsLogo {
  text-align: center;
  margin-bottom: 12px;
}
.modalContsText {
  font-size: 1.3rem;
  line-height: 2;
}
</style>
